import * as React from 'react';
import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import ConfigurationSummary from '../ConfigurationSummary/ConfigurationSummaryContainer.js';
import { PrescriptionUploadSummaryContainer } from '../../../steps/components/PrescriptionUploadSummary/PrescriptionUploadSummaryContainer.js';
import PrescriptionSummary from '../../../steps/components/PrescriptionSummary/PrescriptionSummaryContainer.js';

const RxGlassesExpanderContent = ({ prescriptionType , hasVisitedStepPrescription  })=>/*#__PURE__*/ React.createElement("div", {
        className: "rxglasses-expander-content"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "rxglasses-expander-content__summary"
    }, /*#__PURE__*/ React.createElement(ConfigurationSummary, null)), !hasVisitedStepPrescription ? null : /*#__PURE__*/ React.createElement("div", {
        className: "rxglasses-expander-content__prescription"
    }, CommerceToolsApi.isPrescriptionFile(prescriptionType) ? /*#__PURE__*/ React.createElement(PrescriptionUploadSummaryContainer, null) : /*#__PURE__*/ React.createElement(PrescriptionSummary, null)))
;

export { RxGlassesExpanderContent };
//# sourceMappingURL=RxGlassesExpanderContent.js.map
